<template>
  <v-app>
    <v-navigation-drawer
          v-if="user !== undefined"
          v-model="drawer"
          clipped
          app
          dark
        >
          <v-list-item>
            <v-list-item-title><v-avatar color="accent" class="mt-2 mb-2 mr-3">
      {{user.nom.toUpperCase().substring(0,1)}}{{user.prenom.toUpperCase().substring(0,1)}}
    </v-avatar>{{user.nom}} {{user.prenom}}</v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>

          <v-list>
            <v-list-item
              v-for="item in menu"
              :key="item.title"
              :to="item.href"
              link
            >
              <v-list-item-icon>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              @click="_logout()">
              <v-list-item-icon><v-icon>mdi-exit-to-app</v-icon></v-list-item-icon>
              <v-list-item-title>Déconnexion</v-list-item-title>
            </v-list-item>
          </v-list> 

    </v-navigation-drawer>

    <v-app-bar
      v-if="user !== undefined"
      color="primary"
      dark
      clipped-left
      app
    >
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-img
        alt="Vuetify Name"
        class="shrink"
        contain
        min-width="100"
        src="img/cinestaff.png"
        width="150"
      />

    </v-app-bar>
            
    <v-main>
      <v-container  >
          <router-view />
      </v-container>
    </v-main>
    <v-footer app dark>
      <div class="text-caption" id="copyright">Cinestaff V.{{version}}, &copy; Cinemotion {{moment().year()}}
        Développé par
        <a style="color: #CDCDCD" href="https://audergonv.ch" target="_blank">Vincent Audergon</a>
        <span v-if="devmode" style="color: #d91212"> - Mode développement</span>
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import Swal from "sweetalert2";
import store from "@/store/index.js";
import { isLoggedIn, logout } from "@/auth";
import moment from "moment";

export default {
  data () {
      return {
        devmode: process.env.VUE_APP_DEV_MODE === "true",
        moment,
        drawer: false,
        menu: [
        {
          title: "Accueil", 
          icon: "mdi-home", 
          href:"/"
        },
        {
          title: "Liste des employés",
          icon: "mdi-account-group",
          href: "/employes"
        },
        {
          title: "Mon planning",
          icon: "mdi-clock-outline",
          href: "/horaires/perso"
        },
        {
          title: "Planning général",
          icon: "mdi-clock-outline",
          href: "/horaires/general"
        },
        {
          title: "Particularités",
          icon: "mdi-file-search",
          href: "/horaires/particularites"
        },
        {
          title: "Heures",
          href: "/heures",
          icon: "mdi-timer-sand-empty"
        },
        {
          href: "/remplacements",
          title: "Remplacements / QSP",
          icon: "mdi-account-switch"
        },
        {
          href: "/vacances",
          title: "Vacances",
          icon: "mdi-airplane"
        },
        {
          href: "/about",
          title: "A propos",
          icon: "mdi-information"  
        }
        // {
        //   title: "Options",
        //   icon: "mdi-cog",
        //   href: "/settings"
        // }
      ]
      }
    },
    computed: {
      loading() {
        return store.state.loading;
      },
      user() {
        return store.state.user;
      },
      version(){
        return store.state.version;
      },
      logged() {
        return isLoggedIn();
      },

    },
    methods: {
      onItemClick(event, item) {
        if (item.attributes.type == "logout") this._logout();
      },
      toggleMenu() {
        store.commit("toggleMenu", !store.state.menu);
      },
      _logout() {
        Swal.fire({
          title: "Voulez-vous vous déconnecter?",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Oui",
          cancelButtonText: "Non"
        }).then(result => {
          if (result.value) {
            logout();
          }
        });
      }
    },
    created() {
      if (window.innerWidth >= 1660) {
         this.drawer = true;
      } else{
        this.drawer = false;
      }
    }
};
</script>

<style>
.swal2-container {
  font-family: "Helvetica"
}
</style>
